import ChartContainer from '@synergy/charts';
import useFetch from '../../../server/useFetch';
import { useEffect, useState } from 'react';
import Spinner from './Spinner';
import query from '../../../server/constants.api';
import { Flex } from 'antd';

export const RenderChart = ({ chartdata, charttype, chartquery, idQuery, clickTooltipData, fetchIsLoading, height, width, chartId, params, language, title, isFetching, props }) => {
    // const { data: widgetData, isLoading: widgetDataIsLoading, refetch: refetchWidgetData } = useFetch(chartquery, idQuery, params);//TODO: Eliminar isto apos largar o mockoon
    // const [chartData, setChartData] = useState(null);

    // useEffect(() => {
    //     try {

    //         if (widgetData) {
    //             setChartData(chartquery === query.path.emissionsBySector ? widgetData?.data : widgetData);
    //         }
    //         if (fetchIsLoading) {
    //             fetchIsLoading(isFetching);//To disable dates dropdown when isFetching
    //         }
    //     } catch (error) {
    //         console.error('(RenderChart page) Error in useEffect setting chartData if exists widgetData:', error);
    //         //reportError(error); // Send error report to backend
    //     }
    // }, [widgetData]);

    // useEffect(() => {
    //     try {
    //         if (chartdata) {
    //             setChartData(chartdata);
    //         }
    //         if (fetchIsLoading) {
    //             fetchIsLoading(isFetching);//To disable dates dropdown when isFetching
    //         }
    //     } catch (error) {
    //         console.error('(RenderChart page) Error in useEffect setting chartData:', error);
    //         //reportError(error); // Send error report to backend
    //     }
    // }, [chartdata]);

    // useEffect(() => {
    //     try {
    //         refetchWidgetData();
    //     } catch (error) {
    //         console.error('(RenderChart page) Error in useEffect refetchWidgetData:', error);
    //         //reportError(error); // Send error report to backend
    //     }
    // }, [params])

    return (
        <>
            {
                !isFetching ?
                    <ChartContainer charttype={charttype} clickTooltipData={clickTooltipData} height={height} width={width} chartData={chartdata} chartId={chartId} language={language} title={title} props={props} />
                    : 
                    <Flex justify="center" align='center' style={{height: height}}>
                        <Spinner stroke="green" size="42px" />
                    </Flex>
            }
        </>
    )
}